const API_ENDPOINT = 'https://ipgeolocation.abstractapi.com/v1/?api_key=76b0e29dffb2482bb05174eb5fb74258';
const axios = require('axios');

document.addEventListener('DOMContentLoaded', fetchGeoLocation);

function fetchGeoLocation() {
    axios.get(API_ENDPOINT)
        .then(response => handleCountryDisplay(response.data.country))
        .catch(error => console.error("Error fetching geolocation:", error));
}

function handleCountryDisplay(country) {
    switch (country) {
        case 'United Kingdom':
            showUKContent();
            break;
        case 'United States':
            showUSContent();
            break;
        // Add more countries or a default behavior if needed.

    }
}

function showUKContent() {
    setDisplay('.kam-uk-us, .abstract--uk', 'block');
    setDisplay('.kam-world, .abstract--na', 'none');
    localiseLanguage();
}

function showUSContent() {
    setDisplay('.kam-uk-us', 'block');
    setDisplay('.kam-world', 'none');
}

function setDisplay(selector, value) {
    document.querySelectorAll(selector).forEach(element => {
        if (element) element.style.display = value;
    });
}

function localiseLanguage() {
    const replacements = [
        [/\boptimize\b/g,'optimise'],
        [/\boptimized\b/g,'optimised'],
        [/\boptimization\b/g,'optimisation'],
        [/\boptimizing\b/g,'optimising'],
        [/\banalyze\b/g,'analyse'],
        [/\banalyzed\b/g,'analysed'],
        [/\banalyzing\b/g,'analysing'],
        [/\bpersonalization\b/g,'personalisation'],
        [/\bpersonalize\b/g,'personalise'],
        [/\bpersonalized\b/g,'personalised'],
        [/\bprogram\b/g,'programme'],
        [/\bprograms\b/g,'programmes'],
        [/\borganization\b/g,'organisation'],
        [/\borganizations\b/g,'organisations'],
        [/\bprioritize\b/g,'prioritise'],
        [/\bprioritizing\b/g,'prioritising'],
        [/\bprioritized\b/g,'prioritised'],
        [/\bprioritization\b/g,'prioritisation'],
        [/\bhypothesize\b/g,'hypothesise'],
        [/\bhypothesized\b/g,'hypothesised'],
        [/\bbehavior\b/g,'behaviour'],
        [/\bbehavioral\b/g,'behavioural'],
        [/\bbehaviors\b/g,'behaviours'],
        [/\bmaximize\b/g,'maximise'],
        [/\bmaximized\b/g,'maximised'],
        [/\bmaximization\b/g,'maximisation'],
        [/\bcategorize\b/g,'categorise'],
        [/\bcategorization\b/g,'categorisation'],
        [/\bcategorizing\b/g,'categorising'],
        [/\bspecialize\b/g,'specialise'],
        [/\brandomize\b/g,'randomise'],
        [/\brandomized\b/g,'randomised'],
        [/\borganize\b/g,'organise'],
        [/\borganized\b/g,'organised'],
        [/\blabor\b/g,'labour'],
        [/\bcolor\b/g,'colour'],
        [/\bcolors\b/g,'colours'],
        [/\bcolored\b/g,'coloured'],
        [/\bmonetize\b/g,'monetise'],
        [/\bmonetized\b/g,'monetised'],
        [/\blocalize\b/g,'localise'],
        [/\blocalized\b/g,'localised'],
        [/\blocalization\b/g,'localisation'],
        [/\butilize\b/g,'utilise'],
        [/\butilized\b/g,'utilised'],
        [/\brecognize\b/g,'recognise'],
        [/\brecognized\b/g,'recognised'],
        [/\bcentralized\b/g,'centralised'],
        [/\$/g,'£'],
        [/\b\bOptimize\b\b/g,'Optimise'],
        [/\bOptimized\b/g,'Optimised'],
        [/\bOptimization\b/g,'Optimisation'],
        [/\bOptimizing\b/g,'Optimising'],
        [/\bAnalyze\b/g,'Analyse'],
        [/\bAnalyzed\b/g,'Analysed'],
        [/\bAnalyzing\b/g,'Analysing'],
        [/\bPersonalization\b/g,'Personalisation'],
        [/\bPersonalize\b/g,'Personalise'],
        [/\bPersonalized\b/g,'Personalised'],
        [/\bProgram\b/g,'Programme'],
        [/\bPrograms\b/g,'Programmes'],
        [/\bOrganization\b/g,'Organisation'],
        [/\bOrganizations\b/g,'Organisations'],
        [/\bPrioritize\b/g,'Prioritise'],
        [/\bPrioritizing\b/g,'Prioritising'],
        [/\bPrioritized\b/g,'Prioritised'],
        [/\bPrioritization\b/g,'Prioritisation'],
        [/\bHypothesize\b/g,'Hypothesise'],
        [/\bHypothesized\b/g,'Hypothesised'],
        [/\bBehavior\b/g,'Behaviour'],
        [/\bBehavioral\b/g,'Behavioural'],
        [/\bBehaviors\b/g,'Behaviours'],
        [/\bMaximize\b/g,'Maximise'],
        [/\bMaximized\b/g,'Maximised'],
        [/\bMaximization\b/g,'Maximisation'],
        [/\bCategorize\b/g,'Categorise'],
        [/\bCategorization\b/g,'Categorisation'],
        [/\bCategorizing\b/g,'Categorising'],
        [/\bSpecialize\b/g,'Specialise'],
        [/\bRandomize\b/g,'Randomise'],
        [/\bRandomized\b/g,'Randomized'],
        [/\bOrganize\b/g,'Organise'],
        [/\bOrganized\b/g,'Organised'],
        [/\bLabor\b/g,'Labour'],
        [/\bColor\b/g,'Colour'],
        [/\bColors\b/g,'Colours'],
        [/\bColored\b/g,'Coloured'],
        [/\bMonetize\b/g,'Monetise'],
        [/\bMonetized\b/g,'Monetised'],
        [/\bLocalize\b/g,'Localise'],
        [/\bLocalized\b/g,'Localised'],
        [/\bLocalization\b/g,'Localisation'],
        [/\bUtilize\b/g,'Utilise'],
        [/\bUtilized\b/g,'Utilised'],
        [/\bRecognize\b/g,'Recognise'],
        [/\bRecognized\b/g,'Recognised'],
        [/\bCentralized\b/g,'Centralised']
    ];

    replacements.forEach(([pattern, replacement]) =>
        replaceOnDocument(pattern, replacement)
    );
}

function replaceOnDocument(pattern, string, { target = document.body } = {}) {
    [target, ...target.querySelectorAll("*:not(script):not(noscript):not(style)")].forEach(({ childNodes: [...nodes] }) => 
        nodes.filter(({ nodeType }) => nodeType === document.TEXT_NODE).forEach((textNode) => 
            textNode.textContent = textNode.textContent.replace(pattern, string)
        )
    );
}